import React from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import {BaseStatusTag} from '@modifi/ui'
import {useTranslation} from '@modifi/plugin-i18n'
import {alert} from '@modifi/colors'

const propTypes = {
  children: PropTypes.node,
}
const defaultProps = {
  children: null,
}

type DivergedProps = InferPropTypes<typeof propTypes, typeof defaultProps>

const Diverged: React.FC<DivergedProps> = ({children, ...restProps}) => {
  const {t} = useTranslation('argus')

  return (
    <BaseStatusTag
      backgroundColor={alert}
      dataIdent="shipment-status-tag"
      data-status="diverged"
      iconComponent={null}
      {...restProps}
    >
      {children || t('shipment-status.diverged')}
    </BaseStatusTag>
  )
}

Diverged.propTypes = propTypes
Diverged.defaultProps = defaultProps

export default Diverged
